
$(document).ready(function() {

    // Event Category Click
    $(document).on('click', '.event-category-checkbox', function() { 
        $('.event-category-checkbox').prop('checked', false);
        $(this).prop('checked', true);
        $category_url = $(this).val();
        console.log($category_url);
        window.location= $category_url;
    });

    $('#category-select').on('change', function () {
        window.location.href = $(this).val();
    });

    // Mobile show search
    $(document).on('click', '.search-show', function(e) { 
        e.preventDefault();
        $('.nav-search').toggle();
    });

    if($(window).width() <= 991){
        $('.accordion .accordion-button').addClass('collapsed');
        $('.accordion .accordion-collapse').removeClass('show');  
        console.log("collapsed");  
    }

    $(document).on('click', '.footer-link', function(e) { 
        e.preventDefault();
        if($(window).width() <= 767){
            $(this).parent().find('ul').toggle();
        }
    });

    // Close ad form popup
    $(document).on('click', '#close-ad', function() { 
        // set cookie for 90 days
        setCookie('dtsf-insider-form','1','90'); // (key,value,expiry in days)
        $('#dtsf-popup').hide();

    });

    // Click button in popup ad
    $(document).on('click', '#dtsf-popup-button', function() { 
        // set cookie for 90 days
        setCookie('dtsf-insider-form','1','90'); // (key,value,expiry in days)
        $('#dtsf-popup').hide();

    });

    $(window).scroll(function() {
        var scrollTop = $(this).scrollTop(); // Get the current scroll position

        // job details scroll
        if($('.main-nav').length) {
            var divTop = $('.main-nav').offset().top; // Get the top position of the div
            //console.log(scrollTop + '-' + divTop);
            if(scrollTop < 136.4) {
                $('.main-nav').removeClass('fixed'); // Remove the 'fixed' class
                $('.site-main').removeClass('fixed-nav');
            }
            else if (scrollTop >= divTop) {
                $('.main-nav').addClass('fixed'); // Add the 'fixed' class
                $('.site-main').addClass('fixed-nav');
            } 
        }
        
            
    });
    

});

function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';path=/;expires=' + expires.toUTCString();
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

function eraseCookie(key) {
    var keyValue = getCookie(key);
    setCookie(key, keyValue, '-1');
}